<template>
 <div v-if = "Object.keys(versionInfo).length"
      style = "padding: 1%">
   <div> Version: {{ versionInfo.version }} </div><br>
   <div> Build Number: {{ versionInfo.build }} </div>
 </div>
  <div v-else>
    Unable to show version information
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Version',
  computed: {
    ...mapState('common', [
      'versionInfo',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Version.vue